/* SAINT GALLERIA — Motion controller.
   Enables the motion system only when the visitor allows motion,
   then orchestrates page transitions, staggered scroll reveals,
   the hero word-by-word reveal, soft parallax and the glass
   header. In the Shopify theme editor (design mode), styling is
   applied but behaviour is disabled so the editor works normally.
   All work is passive, rAF-batched, and transform/opacity only.
   v2.1: leave-fade cut 220ms -> 120ms (INP), banner parallax
   upscale cut 1.12 -> 1.04 to stop softening imagery.
   v3.0: gem shine sweep removed entirely. It painted a white
   diagonal band (rgba(255,255,255,0.22)) across cap imagery on
   a 10s loop, which read as an unwanted white block over the
   product. Product presentation takes priority over the effect. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  document.documentElement.classList.add('sg-motion-on');

  /* In the theme editor: keep the look, skip the behaviour. */
  if (window.Shopify && Shopify.designMode) return;

  /* ---------- Logo: hand off from entrance animation to scroll scaling ---------- */
  var logo = document.querySelector('.header__heading-logo, .header__heading-link .h2');
  if (logo) {
    logo.addEventListener('animationend', function () { logo.style.animation = 'none'; }, { once: true });
  }

  /* ---------- Glass header on scroll ---------- */
  var headerTick = false;
  function headerState() {
    document.documentElement.classList.toggle('sg-scrolled', window.scrollY > 48);
  }
  window.addEventListener('scroll', function () {
    if (headerTick) return;
    headerTick = true;
    requestAnimationFrame(function () { headerState(); headerTick = false; });
  }, { passive: true });
  headerState();

  /* ---------- Page-leave fade (soft page transitions) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    e.preventDefault();
    document.documentElement.classList.add('sg-leaving');
    setTimeout(function () { location.href = a.href; }, 120);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.documentElement.classList.remove('sg-leaving');
  });

  /* ---------- Staggered scroll reveals (90ms curation stagger) ---------- */
  var revealSelectors = [
    '.sg-statement', '.sg-trust__item', '.sg-catgrid__card', '.sg-gallery__card', '.sg-coming', '.sg-rv__card', '.sg-thaw-strip',
    '#MainContent .card-wrapper',
    '.collection-hero__title',
    '.multicolumn-card',
    '.image-with-text__grid',
    '.rich-text__wrapper',
    '.newsletter__wrapper',
    '.footer-block',
    '.footer__content-bottom .list-social__item'
  ].join(', ');
  var targets = document.querySelectorAll(revealSelectors);
  if ('IntersectionObserver' in window && targets.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sg-inview');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );
    var seen = [];
    targets.forEach(function (el, i) {
      if (seen.indexOf(el) > -1) return;
      seen.push(el);
      el.classList.add('sg-reveal');
      el.style.setProperty('--sg-reveal-delay', (i % 4) * 90 + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Hero: word-by-word headline reveal ---------- */
  var heading = document.querySelector('.sg-hero__heading');
  if (heading && !heading.dataset.sgSplit) {
    heading.dataset.sgSplit = '1';
    var text = heading.textContent.trim();
    heading.setAttribute('aria-label', text);
    heading.innerHTML = text
      .split(/\s+/)
      .map(function (w, i) {
        return '<span class="sg-word" aria-hidden="true" style="animation-delay:' + (150 + i * 90) + 'ms">' + w + '</span>';
      })
      .join(' ');
  }

  /* ---------- Hero: soft parallax (custom sg-hero sections) ---------- */
  var media = document.querySelector('.sg-hero__media');

  /* ---------- Dawn banners: soft parallax ---------- */
  var banners = [].slice.call(document.querySelectorAll('.banner__media'));

  if (media || banners.length) {
    var pTick = false;
    function parallaxFrame() {
      var vh = window.innerHeight;
      if (media) {
        var y = window.scrollY;
        if (y < vh * 1.2) {
          media.style.transform = 'translateY(' + (y * 0.18).toFixed(1) + 'px)';
        }
      }
      banners.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var img = b.querySelector('img, video');
        if (!img) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = 'scale(1.04) translateY(' + (p * -12).toFixed(1) + 'px)';
      });
      pTick = false;
    }
    window.addEventListener('scroll', function () {
      if (pTick) return;
      pTick = true;
      requestAnimationFrame(parallaxFrame);
    }, { passive: true });
    requestAnimationFrame(parallaxFrame);
  }
})();
